import { createAsyncThunk } from "@reduxjs/toolkit";
import config from '../../config.js'

const API_URL = config.API_URL; // URL da API

/**
 * Thunk para buscar todos os grupos.
 */
export const fetchConfig = createAsyncThunk(
  "groups/fetchConfig",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/config/config`);
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: "Erro ao buscar config, resposta não OK." }));
        throw new Error(errorData.message || "Erro ao buscar config");
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * Thunk para atualizar um Grupo existente.
 * @param {object} configData - Dados do grupo para atualizar.
 * Deve incluir 'id' (ou 'uid') e outros campos: { id, groupName, readers, dashboardsId }
 */
export const updateConfig = createAsyncThunk(
  "groups/updateConfig",
  async (configData, { rejectWithValue }) => {
    const { id, precoHora, horasPorPeso, cotacao, moeda, prioridadeBaixa, prioridadeMedia, prioridadeAlta, precoPorLinhaPowerfeed, linkMockupSpecs, linkPsdMockup, linkEntregaMockup, linkPlanilhaVersoes } = configData; // 'id' aqui é o ID/UID do grupo
    if (!id) {
      return rejectWithValue("ID do grupo é obrigatório para atualização.");
    }
    try {
      const response = await fetch(`${API_URL}/config/config/${id}`, { // URL com ID para PUT
        method: "PUT", // ou PATCH, dependendo da sua API
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            ...configData
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Erro ao atualizar config");
      }
      return data; // Retorna o grupo atualizado
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

